import { makePublishHelper, makeSubscribeHelper } from '../helpers-creators';

const schema = {};

export const commandClose = makePublishHelper(
  'commandClose',
  'wh.common.command.ui.header.deposit.close',
  schema,
);

export const onCommandClose = makeSubscribeHelper(
  'onCommandClose',
  'wh.common.command.ui.header.deposit.close',
  schema,
);
